import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const balmConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Balm Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Balm, FL. Sam\'s Tree Service handles dangerous rural trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_balm',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Balm',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Balm Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we travel to the rural properties 
     of <strong>Balm</strong> in South Hillsborough County to handle the tree 
     work that remote locations demand. Large acreage lots, agricultural properties, 
     and heavy Florida tree growth create conditions where trees become major 
     hazards especially after storm season. Our team brings the right equipment 
     and the experience to manage any size job, no matter how far out it is.`,

    `We specialize in <strong>rural and large lot tree removal and clearing</strong> 
     massive tree takedowns, post storm cleanup across large properties, canopy 
     clearance near homes, barns, and equipment sheds, and debris hauling that 
     fully restores access and safety. We don't turn down remote jobs just 
     because they're off the beaten path.`,

    `<strong>Sam's Tree Service</strong> delivers dependable, affordable tree care 
     throughout <strong>Balm</strong> and the surrounding 
     <strong>South Hillsborough</strong> rural communities giving every 
     property owner the professional service they deserve.`,
  ],
  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Balm, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Balm = () => <LocationPage config={balmConfig} />;
export default Services_Balm;
